import ProgramOverviewSection, {
  IPDPOverviewSectionLayoutBlockProps
} from '@/components/ui/PDP/ProgramOverviewSection';

export const IPDPAdditionalInfo1LayoutBlock = (props: IPDPOverviewSectionLayoutBlockProps) => {
  return <ProgramOverviewSection {...props} sectionName={'additionalInfo1'} />;
};

export default IPDPAdditionalInfo1LayoutBlock;
